export default __webpack_public_path__ + "static/media/sg.e4b110e4.svg";